var SCM = SCM || {};

(function (ns, $) {

    ns.DisableTriggerOnExternalLinks = function () {
        var $hiddenField = $('.hfInterstitial');
        if ($hiddenField.length) {
            var linksToAllow = $hiddenField.data('interstitiallinks').split(',');
            var subdomain = $hiddenField.data('subdomain');
            $('a').filter(function () {
                return shouldDisableTrigger(this, linksToAllow, subdomain);
            }).attr('data-google-interstitial', 'false');
        }
    };

    function shouldDisableTrigger(link, linksToAllow, subdomain) {
        if (link.hostname && link.hostname !== location.hostname) {
            return true;
        }

        if (subdomain && link.href.endsWith(subdomain)) {
            return false;
        }

        for (var linkToAllow of linksToAllow) {
            if (link.href.indexOf(linkToAllow) > -1) {
                return false;
            }
        }

        return true;
    }

    ns.init = function () {
        ns.DisableTriggerOnExternalLinks();
    };
}

)(SCM.Interstitial = SCM.Interstitial || {}, jQuery);